const LoggedOutTab = () => {
    return (
        <div className="flex flex-col">
            <a href="/login" className="text-lg text-gray-400 no-underline mb-3 whitespace-nowrap" title="">Log In</a>
            <a href="/create-account" className="text-lg text-gray-400 no-underline mb-3 whitespace-nowrap" title="">Sign Up</a>
        </div>
    )
};

export default LoggedOutTab;